import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PlanQuantitySelector } from "@/apps/partner/components/PlanQuantitySelector/PlanQuantitySelector";
import {
  partnerAddDeviceStepMapping,
  partnerAddDeviceStepPaths,
} from "@/apps/partner/utils/partnerAddDevice.constants";
import { usePartnerAddDeviceContext } from "@/apps/partner/views/AddDevice/PartnerAddDeviceContext";
import { Button } from "@/components/Interface/Button/Button";
import { StepFlowNavigation } from "@/components/Layout/BaseLayouts/StepFlowLayout/StepFlowNavigation";

export const PartnerQuantityStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setAllowedMaxStep } = usePartnerAddDeviceContext();

  const handleContinue = () => {
    setAllowedMaxStep(partnerAddDeviceStepMapping["personal-details"].step);
    navigate(partnerAddDeviceStepPaths["personal-details"]);
  };

  const handleBack = () => {
    navigate(partnerAddDeviceStepPaths["rate-selection"]);
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <PlanQuantitySelector />

      <StepFlowNavigation
        primaryButton={
          <Button variant="primary" onClick={handleContinue}>
            {t("Common.label.forward")}
          </Button>
        }
        secondaryButton={
          <Button variant="secondary" onClick={handleBack}>
            {t("Common.label.back")}
          </Button>
        }
      />
    </div>
  );
};
